import React from "react";

export default function AuthImage() {
  return (
    <div className="hidden md:block md:col-6 lg:col-7 relative">
      <div className="authbg" />
    </div>
  );
}
